import fetch from '../utilities/fetchAxios'

export const uploadPyment = async (body) => {
  const method = 'POST'
  const path = '/payment/v1/upload'
  return fetch(method, path, body)
}
